import { actions, selectors } from 'data'
import { Bank } from 'data/Payments/BankTransfer/types'
import React, { useState } from 'react'
import { connect, ConnectedProps } from 'react-redux'

import BankStatus from './BankStatus'
import YodleeSDK from './YodleeSDK'

type Props = ConnectedProps<typeof connector> & {
  onBack: () => void
  onContinue?: () => void
  onSuccess: (bank: Bank) => void
}

const Yodlee = ({ bank, onBack, onBankCreated, onContinue, onSuccess }: Props) => {
  const [pollingBank, setPollingBank] = useState<boolean>(false)

  if (!bank || bank.partner !== 'YODLEE' || !bank.attributes) {
    // Unexpected!
    return null
  }

  if (pollingBank) {
    return <BankStatus bankId={bank.id} onBack={onBack} onDone={onSuccess} />
  }

  return (
    <YodleeSDK
      data={bank.attributes}
      onBack={onBack}
      onContinue={onContinue}
      onSuccess={(providerAccountId, accountId) => {
        onBankCreated(bank.id, { accountId, providerAccountId })
        setPollingBank(true)
      }}
    />
  )
}

const mapStateToProps = (state) => ({
  bank: selectors.payments.bankTransfer.getNewLinkedBank(state)
})

const mapDispatchToProps = (dispatch) => ({
  onBankCreated: (bankLinkId, attributes) => {
    dispatch(actions.payments.updateBankLink(bankLinkId, attributes))
  }
})

const connector = connect(mapStateToProps, mapDispatchToProps)
export default connector(Yodlee)
